import VariantModal from './VariantModal';

export default {
  VariantModal,
};
